<template>
  <div id="user-management">
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>Guru</li>
      <li class="active">List Guru</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Aktivasi Guru</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
          <div class="panel-heading" style="display:flex; justify-content:space-between; align-items:center;">
            <div style="width:50%;">
              Daftar Guru
            </div>
            <div>
              <button class="btn btn-success" style="padding:5px; font-size: 11px;" @click="showDownloadKonsul('report')">Unduh Data Konsul</button>
              <button class="btn btn-primary" style="padding:5px; font-size: 11px;" @click="showDownloadKonsul('recap_report')">Unduh Rekap Konsul</button>
            </div>
          </div>
          <div class="panel-body">
            <div class="row">
              <div class="col-md-4">
                <div class="searchbox" style="width:100%;">
                  <input type="text" class="form-control" v-model="query" @keyup.enter="loadTeachersData(1)" placeholder="Masukkan kata kunci dan tekan enter">
                </div>
              </div>
              <div class="col-md-3">
                  <select class="form-control" v-model="filter.mapel">
                    <option value="" selected disabled hidden>Mata Pelajaran</option>
                    <option value="">All</option>
                    <option  :value="item.id" v-for="(item, index) in mapels" :key="index">{{ item.displayName }}</option>
                  </select>
              </div>
              <div class="col-md-3">
                  <select class="form-control" v-model="filter.status" placeholder="Status">
                    <option value="" selected disabled hidden>Status</option>
                    <option value="">All</option>
                    <option value="true">Aktif</option>
                    <option value="false">Terdaftar</option>
                  </select>
              </div>
              <div class="col-md-2">
                <button type="button" @click="loadTeachersData(1)" class="btn btn-success">Apply</button>
              </div>
            </div>
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Nama Guru</th>
                  <th>Email</th>
                  <th>Expired Date</th>
                  <th>Nomor Pegawai</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(teacher, key) in teachers" v-bind:key="key" @dblclick="goToDetail(teacher.user_id)">
                  <td>{{ (15 * (pageNumber - 1)) + (key + 1) }}</td>
                  <td>{{ teacher.name }}</td>
                  <td>{{ teacher.email }}</td>
                  <td>{{ teacher.expired_at }}</td>
                  <td>{{ teacher.employee_id }}</td>
                  <td>
                    <span v-if="teacher.is_verified">Aktif</span>
                    <span style="color:red;" v-else>Terdaftar</span>
                  </td>
                  <td>
                      <button
                      @click="deleteTeacher(teacher)"
                      class="btn btn-danger btn-xl"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="panel-footer">
            <div class="btn-group">
              <button class="btn btn-white" :disabled="pageNumber === 1" type="button" @click="loadTeachersData(--pageNumber)">
                Previous
              </button>
              <input type="text" class="form-control" readonly :value="pageNumber" style="width: 50px; text-align: center">
              <button class="btn btn-white" :disabled="isDisabledNextBtn" type="button" @click="loadTeachersData(++pageNumber)">
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL DOWNLOAD KONSUL REKAP -->
    <div class="modal fade bs-example-modal-sm" id="modalDownloadKonsul" tabindex="-1" role="dialog" aria-labelledby="FilterModal" aria-hidden="true">
    <div class="modal-dialog modal-sm" role="document" style="max-width: 300px !important; ">
        <div class="modal-content">
          <div class="modal-header" style="display:flex; justify-content:space-between;">
            <h4 id="exampleModalLongTitle">Download Rekap Konsul</h4>
            <button type="button" class="close" data-dismiss="modal" style="position:absolute;right:15px;" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="margin:0;">
            <div class="list-group">
              <form action="submit">
                <label for="basic-url">Tanggal Mulai</label>
                <div class="input-group" style="margin-bottom: 20px;">
                  <date-picker v-model="consul.started_at" value-type="timestamp" valueType="format"></date-picker>
                </div>
                <label for="basic-url">Tanggal Akhir</label>
                <div class="input-group" style="margin-bottom: 20px;">
                  <date-picker v-model="consul.ended_at" value-type="timestamp" valueType="format"></date-picker>
                </div>
                <div>
                  <button type="button" class="btn btn-success" style="padding:5px; font-size: 11px;" @click="downloadKonsul()">Unduh File</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>
<script>
import axios from 'axios'
import AppSpinner from '@/components/plugins/Spinner'
import DataTable from '@/components/plugins/DataTable'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment'

export default {
  name: 'user-management',
  components: {
    'app-spinner': AppSpinner,
    'app-datatable': DataTable,
    DatePicker
  },
  data: function () {
    return {
      reportType: 'report',
      query: '',
      filter: {
        mapel: '',
        status: ''
      },
      isLoading: false,
      pageNumber: 1,
      teachers: [],
      total_page: 0,
      isDisabledNextBtn: false,
      mapels: [],
      consul: {
        started_at: null,
        ended_at: null
      }
    }
  },
  watch: {
    // pageNumber: function(newVal) {
    //   this.loadTeachersData(newVal)
    // }
  },
  methods: {
    loadTeachersData: function (pageNumber = 1) {
      this.pageNumber = pageNumber
      var context = this
      var token = this.$ls.get('token');
      var url = process.env.API_BASE_URL + '/account/teachers'

      this.isLoading = true
      var http = axios.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })
      var objParams = '{"order": "DESC","page_size": 15, "page": ' + pageNumber
      if(this.query !== '') objParams += ', "search": "' + this.query + '"'
      if(this.filter.mapel !== '') objParams += ', "mapel_scope_id": ' + this.filter.mapel
      if(this.filter.status !== '') objParams += ', "is_active": "' + this.filter.status + '"'


      objParams += '}'

      http.get(url, {
        params: JSON.parse(objParams)
      })
      .then(function(response) {
        context.teachers = response.data
      })
      .catch(function (error) {
        console.log(error.message)
      })
      .then(function() {
        context.isLoading = false
      })
    },
    loadMapels: function (pageNumber = 1) {
      var context = this
      var token = this.$ls.get('token');
      var url = process.env.API_BASE_URL + '/account/teacher/scopes'

      // this.isLoading = true
      var http = axios.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })

      http.get(url)
      .then(function(response) {
        context.mapels = response.data
      })
      .catch(function (error) {
        console.log(error.message)
      })
      .then(function() {
        // context.isLoading = false
      })
    },

    goToDetail: function(id) {
      this.$router.push('teacher-detail/' + id)
    },
    downloadKonsul(){
      let context = this
      var token = this.$ls.get('token');
      context.isLoading = true
      var url = process.env.API_BASE_URL + '/konsul/consultations/'+this.reportType+'?started_at=' + moment(context.consul.started_at + ' 00:00:00').unix() + '&ended_at=' + moment(context.consul.ended_at + ' 23:59:59').unix() + '&status=finished'

        // this.isLoading = true
        var http = axios.create({
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
          }
        })

        http.get(url, {
          responseType: 'blob',
        })
        .then(function(response) {
          var filename = context.reportType == 'report' ? 'Data Konsul ' : 'Rekap Konsul '
          filename +=  moment(context.consul.started_at).format('DD MMM YYYY') + ' - '+ moment(context.consul.ended_at).format('DD MMM YYYY') + '.xlsx'

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // IE variant
            window.navigator.msSaveOrOpenBlob(
              new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              }), filename
            )
          } else {
            const url = window.URL.createObjectURL(
              new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              })
            )
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
          }
        })
        .catch(function (error) {
          alert('Download file gagal')
          console.log(error.message)
        })
        .then(function() {
          context.isLoading = false
        })

    },
    deleteTeacher(item){
      var context = this
      if (confirm("Apakah anda yakin akan menghapus data guru ini") == true) {
        var token = this.$ls.get('token');
        var url = process.env.API_BASE_URL + '/account/teacher/' + item.user_id

        // this.isLoading = true
        var http = axios.create({
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
          }
        })

        http.delete(url)
        .then(function(response) {
          alert('Hapus data guru berhasil')
          context.loadTeachersData(1)
        })
        .catch(function (error) {
          alert('Hapus data guru gagal')
          console.log(error.message)
        })
        .then(function() {
          // context.isLoading = false
        })
      } else {

      }
    },
    showDownloadKonsul(reportType){
      this.reportType = reportType
      $('#modalDownloadKonsul').modal('show')
    }
  },
  mounted: function () {
    this.loadTeachersData()
    this.loadMapels()
  }
}
</script>




// WEBPACK FOOTER //
// Teachers.vue?f7a02322